"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleValueOperand = void 0;
const market_rule_operand_1 = require("./market-rule-operand");
class MarketRuleValueOperand extends market_rule_operand_1.MarketRuleOperand {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.type = obj.type;
            this.fid = obj.fid;
            this.blankValue = obj.blankValue;
        }
    }
}
exports.MarketRuleValueOperand = MarketRuleValueOperand;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtdmFsdWUtb3BlcmFuZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy90aW1lLXNlcmllcy9zZXJ2aWNlcy9ydWxlLWVuZ2luZS1zZXJ2aWNlL2NsYXNzZXMvbWFya2V0LXJ1bGUtdmFsdWUtb3BlcmFuZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSwrREFBMEQ7QUFFMUQsTUFBYSxzQkFBdUIsU0FBUSx1Q0FBaUI7SUFLekQ7OztPQUdHO0lBQ0gsWUFBbUIsR0FBcUM7UUFDcEQsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBRVgsSUFBSSxHQUFHLEVBQUUsQ0FBQztZQUNOLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLElBQUssQ0FBQztZQUN0QixJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQyxHQUFJLENBQUM7WUFDcEIsSUFBSSxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUMsVUFBVyxDQUFDO1FBQ3RDLENBQUM7SUFDTCxDQUFDO0NBQ0o7QUFsQkQsd0RBa0JDIn0=